const catalogos = [{
    name : 'grupos',
    caption : 'Categoria de Productos',
    url : 'familias'
},{
    name : 'marcas',
    caption : 'Marcas',
    url : 'presentaciones'
},{
    name : 'unidadmedida',
    caption : 'Unidad de Medida',
    url : 'ums'
},{
    name : 'bancos',
    caption : 'Bancos',
    url : 'banks'
},{
    name : 'gruponotacredito',
    caption : 'Justificación Nota de Crédito',
    url : 'movementgroups'
},{
    name : 'cateroria-gastos',
    caption : 'Categoria de Gastos',
    url : 'gastosCategorias'
}];



export default catalogos;